export type FontKey = "noto-sans-jp" | "mplus-rounded" | "kosugi-maru" | "sawarabi-gothic";

export interface FontConfig {
    name: string;
    family: string;
    url: string;
}

export const FONT_CONFIGS: Record<FontKey, FontConfig> = {
    "noto-sans-jp": {
        name: "Noto Sans JP",
        family: "'Noto Sans JP', sans-serif",
        url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap"
    },
    "mplus-rounded": {
        name: "M PLUS Rounded 1c",
        family: "'M PLUS Rounded 1c', sans-serif",
        url: "https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c:wght@400;500;700&display=swap"
    },
    "kosugi-maru": {
        name: "Kosugi Maru",
        family: "'Kosugi Maru', sans-serif",
        url: "https://fonts.googleapis.com/css2?family=Kosugi+Maru&display=swap"
    },
    "sawarabi-gothic": {
        name: "Sawarabi Gothic",
        family: "'Sawarabi Gothic', sans-serif",
        url: "https://fonts.googleapis.com/css2?family=Sawarabi+Gothic&display=swap"
    }
};

export function loadWebFont(fontKey: FontKey, shadowRoot?: ShadowRoot): void {
    const fontConfig = FONT_CONFIGS[fontKey];

    if (!fontConfig) {
        return;
    }

    const targetDocument = shadowRoot || document;
    const targetHead = shadowRoot || document.head;

    const existingLink = targetDocument.querySelector(`link[data-font="${fontKey}"]`);
    if (existingLink) {
        return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontConfig.url;
    link.setAttribute('data-font', fontKey);
    targetHead.appendChild(link);
}

export function applyFontToElement(element: HTMLElement, fontKey: FontKey): void {
    const fontConfig = FONT_CONFIGS[fontKey];

    if (!fontConfig) {
        return;
    }

    element.style.fontFamily = fontConfig.family;
}
